import EnvironmentBanner from './environmentBanner.vue'; // 引入 Vue 组件

const BackgroundPlugin = {
    install(Vue) {
        // 获取当前环境
        const env = process.env.NODE_ENV;

        // 如果是测试环境或开发环境，注册全局组件
        if (env === 'development') {
            Vue.component('EnvironmentBanner', EnvironmentBanner);
        }
    }
};

export default BackgroundPlugin;